import React, { useEffect, useMemo, useState } from "react";
import DataTable from "../../DataTable/index";
import IconButton from "@mui/material/IconButton";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { Box, Button, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
// import MainModal from "../MainModal";

export default function MyComponent(props) {
  const [filterText, setFilterText] = useState("");
  // const filteredItems = props.addSeason.filter(
  //   (item) =>
  //     item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
  // );

  // const [professionList, setProfessionList] = useState([]);
  // const [show, setShow] = useState(false);
  // const [selectedRow, setSelectedRow] = useState({});

  // const baseEndpointURL =
  //   ApiEndpoints.root +
  //   ApiEndpoints.management.base +
  //   ApiEndpoints.management.profession.base;

  useEffect(() => {
    // props.getDataList();

    // console.log("props.professionList", props.professionList);
    return () => {
      //   props.getDataList();
    };
  }, []);

  const columns = [
    {
      name: (
        <Typography variant="subtitle2" fontWeight={700}>
          Name
        </Typography>
      ),
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => <Box component='span' sx={{ textDecoration: 'underline' }}>{row.name}</Box>
    },
    {
      name: (
        <Typography variant="subtitle2" fontWeight={700} sx={{
          width: '50% !important',
          textAlign: 'center !important',
        }}>
          Type
        </Typography>
      ),
      selector: (row) => row.league_type,
      sortable: true,
      cell: (row) => <Box sx={{
        width: '50% !important',
        textAlign: 'center !important',
      }}>{row.league_type}</Box>
    },
    {
      name: (
        <Typography variant="subtitle2" fontWeight={700} sx={{
          width: '50% !important',
          textAlign: 'center !important',
        }}>
          Year
        </Typography>
      ),
      selector: (row) => row.season_id,
      sortable: true,
      cell: (row) => <Box sx={{
        width: '50% !important',
        textAlign: 'center !important',
      }}>{row.season_id}</Box>
    },
    {
      name: (
        <Typography variant="subtitle2" fontWeight={700} sx={{
          width: '50% !important',
          textAlign: 'center !important',
        }}>
          Action
        </Typography>
      ),
      sortable: true,
      cell: (row) => (
        <Box sx={{
          width: '50% !important',
          textAlign: 'center !important',
        }}>
          <IconButton
            aria-label="edit"
            // color="black"
            size="small"
            sx={{ color: '#015098' }}
            disableRipple
            onClick={() => {
              props.openEditModal();
              props.setLeagueData((prev) => ({
                ...prev,
                name: row.name,
                seasonID: row.season_id,
                leagueIDforUpdate: row._id,
                league_type: row.league_type,
                handicap_diffrential: row.handicap_diffrential,
                third_position_play_off:
                  row.season_description.third_position_play_off.toString(),
                no_of_players: row.season_description.no_of_players,
                scoringMethod: row.season_description.scoring_method,
                noOfTeams: row.season_description.no_of_teams,
                playersPerTeam: row.season_description.players_per_team,
                noOfCaptains: row.season_description.no_of_captains,
                matchesPerRound: row.season_description.no_of_matches_per_round,
                pointsystemID: row.season_description.point_system_ID,
              }));
            }}
          >
            <EditRoundedIcon />
          </IconButton>
          <IconButton
            sx={{ color: '#B53F3E' }}
            size="small"
            disableRipple
            onClick={() => props.onDelete(row._id)}
          >
            <DeleteRoundedIcon fontSize="medium" />
          </IconButton>
        </Box>
      ),
    },
  ];
  const data = [
    {
      id: 1,
      name: "Beetlejuice",
      type: "poty",
      season: "1988",
    },
    {
      id: 2,
      name: "Ghostbusters",
      type: "poty",
      season: "1984",
    },
    {
      id: 3,
      name: "Beetlejuice",
      type: "poty",
      season: "1988",
    },
    {
      id: 4,
      name: "Ghostbusters",
      type: "poty",
      season: "1984",
    },
  ];

  const conditionalRowStyles = {
    table: {
      style: {
        // background: 'yellow'
      }
    },
    headRow: {
      style: {
        border: '1px solid #C4C4C4',
        borderRadius: "5px",
        padding: '0 !important',
        minHeight: '40px',

      },
    },
    rows: {
      style: {
        minHeight: '10px',
        border: 'none !important',
        borderRadius: "5px",
        background: '#F2F2F2',
        fontWeight: 500,
        padding: '2px 0',

        '&:nth-child(odd)': {
          background: '#fff',
        }
      }
    },
  };
  // const conditionalRowStyles = [
  //   {
  //     when: (columns) => columns,
  //     style: {
  //       borderRadius: "10px",
  //       borderWidth: "1px",
  //       borderStyle: "solid",
  //       borderColor: "black",
  //     },
  //   },
  // ];

  // console.log("props.setSelectedRows", props.setSelectedRows);
  return (
    <DataTable
      columns={columns}
      data={props.leagueListData}
      // selectableRows
      // subHeaderComponent={subHeaderComponentMemo}
      // subHeader
      persistTableHead
      pagination={false}
      customStyles={conditionalRowStyles}
      direction="vertical"
      striped={true}
      onRowClicked={(row, event) => {
        // window.location.href= `/seasonManagement/${row.id}`
        // console.log("row", row);
      }}
      onSelectedRowsChange={({ allSelected, selectedCount, selectedRows }) => {
        props.onChangeSelecteableDelete(selectedRows);
        props.setIsItemSelected(!props.isItemSelected);
      }}
    // onSelectedRowsChange={({ allSelected, selectedCount, selectedRows }) => {
    //   console.log("allSelected", allSelected);
    //   console.log("selectedCount", selectedCount);
    //   console.log("selectedRows", selectedRows);
    //   props.setSelectedRows(selectedRows[0]);
    // }}
    />
  );
}
